import React from "react";
import LinkButton from "./LinkButton";
import structure from "../../assets/REMA/structure-Illustration.svg";
import { useRef } from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { REMA_REGISTRATION_PAGE_URL } from "./constants";
import DownloadBrochureButton from "./DownloadBrochureButton";

const CTA = () => {
  const pathRef = useRef(null);

  useGSAP(() => {
    const path = pathRef.current;
    if (path) {
      const length = path.getTotalLength();
      gsap.set(path, {
        strokeDasharray: length,
        strokeDashoffset: length,
      });

      // Parallax scaling for the structure-illustration image
      const img = document.querySelector(".structure");
      if (img) {
        gsap.to(img, {
          scale: 1.15,
          scrollTrigger: {
            trigger: img,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
          },
          ease: "power1.out",
        });
      }
      gsap.to(path, {
        strokeDashoffset: 0,
        duration: 3,
        ease: "power1.inOut",
        scrollTrigger: {
          trigger: ".container",
          start: "top 80%",
          once: true,
        },
      });
    }
  }, []);

  return (
    <section className="bg-[#0C2926] lg:bg-white relative  overflow-hidden">
      {/* Container */}
      <div className="container mx-auto px-4 md:px-10 md:py-4 lg:my-[100px] relative z-10">
        <div className=" lg:bg-[#0C2926] px-4 md:px-10 py-10 lg:p-[72px] pb-0 lg:pb-[120px] relative overflow-hidden">
          <div className="lg:max-w-[553px] xl:max-w-[553px] relative z-10">
            <h2 className="font-sora text-white text-[24px] lg:text-[28px] md:text-[36px] font-bold lg:font-medium  lg:leading-[46px] text-center lg:text-left">
              Proudly powered by Venco with support from industry leaders
            </h2>
            <div className="mt-8 lg:mt-12">
              {/* <LinkButton
                buttonText="Register now"
                to={REMA_REGISTRATION_PAGE_URL}
              /> */}
              <DownloadBrochureButton />
            </div>
          </div>

          <div className="hidden lg:block lg:absolute lg:-right-16 lg:-bottom-16 z-[1]  ">
            <img src={structure} alt="" className="structure" />
          </div>

          <div className="hidden lg:block absolute right-0 top-1/2 -translate-y-1/2 z-0">
            <svg
              viewBox="0 0 500 642"
              width={500}
              height={642}
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                ref={pathRef}
                d="M498.454 131.953C358.167 138.892 216.511 172.893 102.16 254.745C-247.61 505.109 672.17 887.961 332.516 344.696C260.032 228.761 181.345 116.955 102.16 12.7813"
                stroke="#19443F"
                strokeWidth="41.1061"
              />
            </svg>
          </div>
        </div>
      </div>
      <div
        className=" lg:hidden relative z-[1] w-full
           -bottom-12 "
      >
        <img src={structure} alt="" className="structure w-full scale-150" />
      </div>
    </section>
  );
};

export default CTA;
